var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18973 4L7.88269 1.30704C8.03844 1.15129 8.03844 0.898548 7.88269 0.742551L7.25695 0.116811C7.1012 -0.0389369 6.84846 -0.0389369 6.69246 0.116811L3.99975 2.81002L1.30679 0.117061C1.15104 -0.0386868 0.898299 -0.0386868 0.742301 0.117061L0.116811 0.742551C-0.0389369 0.898299 -0.0389369 1.15104 0.116811 1.30704L2.80977 4L0.116811 6.69296C-0.0389369 6.84871 -0.0389369 7.10145 0.116811 7.25745L0.742551 7.88319C0.898299 8.03894 1.15104 8.03894 1.30704 7.88319L3.99975 5.18998L6.69271 7.88294C6.84846 8.03869 7.1012 8.03869 7.2572 7.88294L7.88294 7.2572C8.03869 7.10145 8.03869 6.84871 7.88294 6.69271L5.18973 4Z",
    fill: "#4A5361"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.d0cdcd71.svg";
export { ForwardRef as ReactComponent };